const problems = [
  {
    title: '設計計算・見積りがベテランのExcelに依存している',
    description: '計算根拠がブラックボックス化し、数式を触れる人がいない。退職や異動で業務が止まるリスクを抱えている。'
  },
  {
    title: '解析（CAE）を使いたいが、ライセンスが高すぎる',
    description: '強度や変形を確認したい場面はあるのに、商用CAEの費用と専任者の壁で「経験と勘」に頼っている。'
  },
  {
    title: '図面が紙・スキャン画像のまま眠っている',
    description: '改修や流用設計のたびに竣工図・旧図面を探し、CADで一から描き直している。元データはもう誰も持っていない。'
  },
  {
    title: '図面からの数量拾い・積算が特定の人の経験頼み',
    description: '見積りのたびに図面から数量を手で拾っている。時間がかかるうえ、拾える人が限られている。'
  },
  {
    title: '写真整理・報告書づくりが残業の原因になっている',
    description: '工事写真の仕分け・黒板情報の転記・点検報告書の作成に、現場監督・技術者の時間が奪われている。'
  },
  {
    title: '紙とExcelの転記作業にデータが埋もれている',
    description: '日報・検査記録は蓄積されているのに、集計に時間がかかり、改善の判断材料にできていない。'
  }
];

export default function Problem() {
  return (
    <section className="doc" id="problem">
      <div className="sheet">
        <p className="sec-label mono">SEC. 01 — 現状の課題</p>
        <h2>その図面と計算、担当者が居なくなっても回りますか？</h2>
        <p className="sec-intro">製造業・建設業の設計・見積り・現場管理で、繰り返し出会う状態です。ひとつでも心当たりがあれば、ご相談ください。</p>
        <div className="check-list">
          {problems.map((problem) => (
            <div className="check-item" key={problem.title}>
              <span className="box" aria-hidden="true"></span>
              <div>
                <h3>{problem.title}</h3>
                <p>{problem.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
